// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { useEmbeddedOnboarding } from '../employer_onboarding/useEmbeddedOnboarding'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type QuoteAllowanceClass = {
  location_type?: 'rating_area' | 'state',
  location_id?: string,
  employment_type?: 'part_time' | 'full_time',
  pay_type?: 'hourly' | 'salary',
  max_age?: number,
  min_age?: number,
}

export type QuoteAllowanceDynamicConfig = {
  coverage_percentile: number,
  benchmark: string,
  employee_contribution_percentage: number,
  spouse_contribution_percentage: number,
  dependent_contribution_percentage: number,
}

export type QuoteAllowanceFlatConfig = {
  employee_amount: number,
  spouse_amount: number,
  dependent_amount: number,
  max_dependent_count: number,
}

export type QuoteAllowanceParams = {
  class?: QuoteAllowanceClass,
  dynamic_config?: QuoteAllowanceDynamicConfig,
  flat_config?: QuoteAllowanceFlatConfig,
  qme_treatment?: 'all_allowed' | 'disabled' | 'copay_only',
}

export function useCreateQuoteAllowances ({
  prospectId,
  quoteId,
  removeExisting = false,
}: {
  prospectId: string,
  quoteId: string,
  removeExisting?: boolean,
}) {
  const { embeddedOnboardingToken: token } = useEmbeddedOnboarding()
  return useMutation<void, GrapeAPIErrorType, QuoteAllowanceParams[]>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/allowances`,
        {
          body: {
            allowances: params,
            remove_existing: removeExisting,
          },
          headers: token ? { 'Thatch-Onboarding-Session-Client-Secret': token } : {},
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
    },
  })
}
